// CalculatorButton.tsx
import React from 'react';

interface CalculatorButtonProps {
  label: string;
  onClick: () => void;
}

const CalculatorButton: React.FC<CalculatorButtonProps> = ({ label, onClick }) => (
  <button onClick={onClick}>{label}</button>
);

export default CalculatorButton;
